export default __webpack_public_path__ + "static/media/600.e9f589d2.woff2";